<div [formGroup]="mercadoriaForm" >
    <div class="canvas">

      <div style="width: 100%;">
        <div class="form-group">
          <div style="width: 90%;">
            <label for="tipoMercadoria">Mercadoria</label>
            <select
                class="form-control"
                required
                appShowErrorMessages
                requiredMessage="O campo Mercadoria é obrigatório"
                name="tiposMercadoria"
                formControlName="tiposMercadoria">
              <option value="" hidden selected>Selecione</option>
              <option
                  *ngFor="let tipoMercadoria of tiposMercadoria"
                  value="{{ tipoMercadoria.id }}">
                {{ tipoMercadoria.descricao }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <div style="width: 90%;">
            <label for="valorProduto">Valor do Produto</label>
            <input
                class="form-control"
                required
                type="text"
                placeholder="R$ 00.000,00"
                appOnlyDigitsLengthValidator
                appShowErrorMessages
                requiredMessage="O campo Valor do Produto é obrigatório"
                formControlName="valorProduto"
                name="valorProduto"
                mask-money
                [prefix]="'R$'"
                appMoedaValidator
                valorMinimoMessage="Valor mínimo permitido R$"
                valorMinimo="200"
                [maxLength]="15"
                disabled>
          </div>
        </div>
      </div>

      <div>
        <div *ngIf="!valorDisabled" class="delete-button">
          <p (click)="selfDestruct()"><i class="fa fa-trash"></i></p>
        </div>
      </div>

    </div>

</div>
